/**
 * Adds an unique class for each page/route to the app container.
 *
 * @namespace
 * @alias tmrContentClass
 * @type {ngDirective}
 * @todo example
 */
function TmrContentClassDirective($state) {
  'ngInject'
  return {
    restrict: 'A',
    link,
  }

  function link(scope, element) {
    element.addClass(
      $state.current.name
        .replace(/^app/, 'page')
        .replace(/\./g, '-')
        .toLowerCase()
    )
  }
}

export const directive = ['tmrContentClass', TmrContentClassDirective]
